module.exports = {
  slug: 'anti-sound-system',
  name: 'Anti Sound System',
  links: [],
}
